__turbopack_context__.v({
  "brand-check-pop": "fWD-BW_brand-check-pop",
  "brand-entrance-up": "fWD-BW_brand-entrance-up",
  "brand-glow-pulse": "fWD-BW_brand-glow-pulse",
  "brand-item-in": "fWD-BW_brand-item-in",
  "brand-panel-in": "fWD-BW_brand-panel-in",
  "brand-ring-breathe": "fWD-BW_brand-ring-breathe",
  "brand-sheen": "fWD-BW_brand-sheen",
  "heroEntrance": "fWD-BW_heroEntrance",
  "heroEntranceDelay1": "fWD-BW_heroEntranceDelay1",
  "heroEntranceDelay2": "fWD-BW_heroEntranceDelay2",
  "heroEntranceDelay3": "fWD-BW_heroEntranceDelay3",
  "heroEntranceDelay4": "fWD-BW_heroEntranceDelay4",
  "trustCheck": "fWD-BW_trustCheck",
  "trustCheckDelay1": "fWD-BW_trustCheckDelay1",
  "trustCheckDelay2": "fWD-BW_trustCheckDelay2",
  "trustCheckDelay3": "fWD-BW_trustCheckDelay3",
  "trustGlow": "fWD-BW_trustGlow",
  "trustItem": "fWD-BW_trustItem",
  "trustItemDelay1": "fWD-BW_trustItemDelay1",
  "trustItemDelay2": "fWD-BW_trustItemDelay2",
  "trustItemDelay3": "fWD-BW_trustItemDelay3",
  "trustPanel": "fWD-BW_trustPanel",
  "trustRingSoft": "fWD-BW_trustRingSoft",
  "trustRingSoftDelay": "fWD-BW_trustRingSoftDelay",
  "trustSheen": "fWD-BW_trustSheen",
});
